import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { Logger } from 'angular2-logger/core'

import { DragService } from './drag.service'
import { DropTargetOptions } from './drop-target-options'

@Directive({
  selector: '[appDropTarget]'
})
export class DropTargetDirective {

  constructor(private dragService: DragService,
              private logger: Logger) {
  }

  @Input()
  set appDropTarget(options: DropTargetOptions) {
    if (options) {
      this.options = options
    }
  }

  @Output('appDrop') drop = new EventEmitter()

  private options: DropTargetOptions = {zone: 'zone'}

  @HostListener('dragenter', ['$event'])
  @HostListener('dragover', ['$event'])
  onDragOver(event) {
    event.preventDefault()
  }

  @HostListener('drop', ['$event'])
  onDrop(event) {
    try {
      const data = JSON.parse(event.dataTransfer.getData('Text'))
      if (data.zone !== this.options.zone) {
        return
      }
      this.drop.next(data)
    } catch (error) {
      // this.logger.error('Could not parse dropped item, err:', error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dnd/drop-target.directive.ts